module.exports = __webpack_public_path__ + "img/store.e1f84ffb.jpg";